import React from 'react';

export default function PersonalContact({userEmail,userContact, setUserContact}) {

  const onChangeHandler = (event) => {
    const { name, value } = event.currentTarget;
    if (name === "officeWebsite") {
      setUserContact({...userContact,[name]: value});
    } else if (name === "userLinkedIn") {
      setUserContact({...userContact,[name]: value});
    } else if (name === "officeFacebook") {
      setUserContact({...userContact,[name]: value});
    }
  }
  return (
    <div>
    <div className="header-and-save">
        <h3>יצירת קשר ומדיה מקצועית וחברתית</h3>
      </div>
      <div className="update-page-contact">
        <div className="profile-update-labelinput-wrapper">
          <label className="profile-update-label" htmlFor="mail">
              :כתובת אימייל
          </label>
          <input
            className="profile-update-input"
            value = {userEmail}
            name="mail"
            disabled
          />
        </div> 

        <div className="profile-update-labelinput-wrapper">
          <label className="profile-update-label" htmlFor="officeWebsite">
              :קישור לאתר האינטרנט המשרדי (העתק לכאן את שורת כתובת האתר)
          </label>
          <input
            className="profile-update-input"
            type="text"
            name="officeWebsite"
            value = {userContact.officeWebsite}
            onChange={event => onChangeHandler(event)}
          />
        </div>

        <div className="profile-update-labelinput-wrapper">
          <label className="profile-update-label" htmlFor="userLinkedIn">
              :קישור לדף הלינקדאין (העתק לכאן את שורת כתובת האתר)
          </label>
          <i style={{marginRight: "5px", color:"#3b5998"}} class="fa fa-linkedin"></i>
          <input
            className="profile-update-input"
            type="text"
            name="userLinkedIn"
            value = {userContact.userLinkedIn}
            onChange={event => onChangeHandler(event)}
          />
        </div>

        <div className="profile-update-labelinput-wrapper">
          <label className="profile-update-label" htmlFor="officeFacebook">
              :קישור לדף הפייסבוק המקצועי של המשרד (העתק לכאן את שורת כתובת האתר)
          </label>
          <i style={{marginRight: "5px", color:"#3b5998"}} class="fa fa-facebook-square"></i>
          <input
          className="profile-update-input"
          type="text"  
          name="officeFacebook" 
          value = {userContact.officeFacebook}
          onChange={event => onChangeHandler(event)}
          />
        </div>
      </div>
    </div>
  );
}